import { FC } from 'react';

import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { TBreadCrumb } from 'src/types/Breakcrumbs/breadcrumb.model';

type BreadCumsProps = {
  breadcrumb: TBreadCrumb[];
};

const BreakCrumbs: FC<BreadCumsProps> = ({ breadcrumb }) => {
  return (
    <>
      <Box display="flex">
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          {breadcrumb &&
            breadcrumb.map((item: TBreadCrumb, index) => {
              if (item.path) {
                return (
                  <Link underline="hover" key={index} color="inherit" href={item.path}>
                    {item.icon && item.icon}
                    {item.name}
                  </Link>
                );
              } else {
                return (
                  <Typography key={index} sx={{ display: 'flex', alignItems: 'center' }} color="text.primary">
                    {item.name}
                  </Typography>
                );
              }
            })}
        </Breadcrumbs>
      </Box>
    </>
  );
};

export default BreakCrumbs;
